import { AbstractControl } from '@angular/forms';

/**
 * Validates:
 *   - Contain only numbers
 *   - Number must be greater than 0
 */
export function ValidateVolume() {
	return (control: AbstractControl) => {
		if (!control || !control.value) {
			return null;
		}

		const volume = control.value;

		// Allow integers or decimals with up to 2 decimal places
		const isValid = /^\d+(\.\d{1,2})?$/.test(volume);
		if (!isValid) {
			return { invalidVolume: true };
		}

		const minimumVolume = 0;
		if (Number.parseFloat(volume) < minimumVolume) {
			return { invalidVolume: true };
		}

		return null;
	};
}
